import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata,
  allHubs,
  columns,
  searchBy,
  applyFiltersExternally,
  onHubChange,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  totalRows,
  searchText,
  setSearchText,
  workingHoursFilter,
  setWorkingHoursFilter,
  date,
  setDate,
}) {
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [hubFilter, setHubFilter] = useState("");
  const today = new Date().toISOString().split("T")[0];

  const applyFilters = () => {
    setCurrentPage(1);

    onHubChange(hubFilter);

    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setHubFilter("");

    onHubChange("");

    setWorkingHoursFilter("");

    setSearchText("");

    setDate(today);

    setCurrentPage(1);

    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={apidata}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={rowsPerPage}
        paginationDefaultPage={currentPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newPerPage) => {
          const firstRowIndex = (currentPage - 1) * rowsPerPage;

          const newPage = Math.floor(firstRowIndex / newPerPage) + 1;

          setRowsPerPage(newPerPage);

          setCurrentPage(newPage);
        }}
        fixedHeader
        highlightOnHover
        responsive
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        allHubs={allHubs}
        hubFilter={hubFilter}
        setHubFilter={setHubFilter}
        date={date}
        setDate={setDate}
        workingHoursFilter={workingHoursFilter}
        setWorkingHoursFilter={setWorkingHoursFilter}
      />
    </div>
  );
}
